var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      filter: "invert(1)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6601 13C34.3424 13 19.9583 14.1562 12.2995 15.7732C7.19659 16.9294 2.78256 20.3982 1.85806 25.7188C0.933564 31.2651 0 39.5938 0 50C0 60.4062 0.9245 68.5 2.08466 74.2812C3.01822 79.3669 7.42319 83.0706 12.5261 84.2268C20.6562 85.8438 34.569 87 49.8867 87C65.2044 87 79.1172 85.8438 87.2383 84.2268C92.3502 83.0706 96.7552 79.6018 97.6797 74.2812C98.6133 68.5 99.7734 60.1804 100 49.7742C100 39.3679 98.8398 31.0393 97.6797 25.2581C96.7552 20.1724 92.3502 16.4688 87.2383 15.3125C79.1172 14.1562 64.9687 13 49.6601 13ZM49.6601 17.625C66.3645 17.625 79.8151 19.0071 86.3138 20.1633C89.7943 21.0938 92.5768 23.4063 93.0391 26.4143C94.4349 33.8125 95.3594 41.6804 95.3594 49.7742C95.1328 59.7107 93.9726 67.8044 93.0391 73.5857C92.3502 77.9758 87.7096 79.3669 86.3138 79.8367C77.957 81.4536 64.0352 82.6008 50.1133 82.6008C36.1914 82.6008 22.043 81.6794 13.9219 79.8367C10.4414 78.9062 7.65884 76.5937 7.19659 73.5857C5.33853 67.1089 4.64062 58.5544 4.64062 50C4.64062 39.3589 5.57419 31.5 6.49868 26.6492C7.19659 22.25 12.0638 20.8589 13.224 20.3982C20.8828 18.7812 35.0403 17.625 49.6601 17.625ZM37.125 31.5V68.5L69.6094 50L37.125 31.5ZM41.7656 39.3679L60.3281 50L41.7656 60.6321V39.3679Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.16038422e83f82a70381da155054e29e.svg";
export { ForwardRef as ReactComponent };